var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.programKeywords && _vm.row.programKeywords.length > 0)?_c('div',_vm._l((_vm.row.programKeywords),function(keyword,idx){return _c('div',{key:'keyword' + idx,staticClass:"keyword-container"},[_vm._v("\n        "+_vm._s(keyword.keyword.name)+"\n    ")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311e378a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Programme/ProgramKeywordChip.vue
// module id = null
// module chunks = 